export enum ChaosTableStatus {
   SUCCESSFUL = 'SUCCESSFUL',
   UNSUCCESSFUL = 'UNSUCCESSFUL',
   OPEN = 'OPEN'
}

export enum PaymentMethod {
   SIMPLE_PAY = 'SIMPLE_PAY',
   CASH = 'CASH',
   NONE = 'NONE',
   LINK_SENT = 'LINK_SENT',
   STUDENT_WAS_DELETED = 'STUDENT_WAS_DELETED'
}

export enum Source {
   API = 'API',
   FILE = 'FILE',
   MANUAL = 'MANUAL'
}
